import {UUID_REGEX} from '@imt/vue-toolbox/src/utils';
export default [
    {
        path: '/',
        component: () => import(/* webpackChunkName: "VBase" */ '@/views/VBase.vue'),
        children: [
            {
                path: '',
                redirect: {
                    name: 'set.list',
                },
            },
            {
                path: 'sets',
                name: 'set.list',
                meta: {
                    title: 'Sets',
                },
                component: () => import(/* webpackChunkName: "VSetList" */ '@/views/VSetList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'set.add',
                        component: () => import(/* webpackChunkName: "VSetAddModal" */ '@/views/VSetAddModal.vue'),
                    },
                    {
                        path: `/options/:setId(${UUID_REGEX})`,
                        name: 'set.edit',
                        component: () => import(/* webpackChunkName: "VSetOptionsModal" */ '@/views/VSetOptionsModal.vue'),
                    },
                ],
            },
            {
                path: `sets/:setId(${UUID_REGEX})`,
                name: 'set.detail',
                component: () => import(/* webpackChunkName: "VSetDetail" */ '@/views/VSetDetail.vue'),
            },
            {
                path: `sets/:setId(${UUID_REGEX})/activity`,
                name: 'set.activity',
                meta: {
                    title: 'Set Activity',
                },
                component: () => import(/* webpackChunkName: "VSetActivityList" */ '@/views/VSetActivityList.vue'),
                children: [],
            },
        ],
    },
    // Fallback
    {
        path: '*',
        name: 'not-found',
        meta: {
            title: 'Not Found',
        },
        component: () => import(/* webpackChunkName: "KCNotFound" */ '@imt/vue-kit-car/src/components/errors/NotFound.vue'),
    },
];
